export const DOCUMENTS_NAMESPACE = 'Documents';
export const DOCUMENT_INTERACTION_EVENT_NAME = 'Document Interaction';
export const BUTTON_HOVER_EVENT_NAME = 'Button Hover';
export const UPLOAD_FILE_EVENT_NAME = 'Upload File';
export const DOCUMENT_DESCRIPTION_EVENT_NAME = 'Document Description Interaction';